export const initPageScroll = () => {
	const buttonScrollTop = document.querySelector(  'button.scroll-page' );
	
	if ( !buttonScrollTop )
	{
		return;
	}
	
	let windowScrollTop = 0;
	
	buttonScrollTop.addEventListener( 'click', () => {
		window.scrollTo( { top: 0, behavior: 'smooth' } );
	} );
	
	window.addEventListener(`scroll`, (evt) => {
		if ( window.pageYOffset < windowScrollTop && window.pageYOffset > 300 )
		{
			buttonScrollTop.classList.add( 'show' );
		}
		else
		{
			buttonScrollTop.classList.remove( 'show' );
		}
		
		windowScrollTop = window.pageYOffset;
	});
};
